import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import { useGetProduct } from 'hooks/useGetProduct/useGetProduct';
import { FEELIX_THEMES, SUBSCRIPTION_TYPE } from '../../constants';

export const usePromoCodeBoxEnabled = (): boolean => {
  const { subscriptionType, theme, activationCode, addonIds } = useSessionContext();
  const { isSuccess, isLoading, productData } = useGetProduct();
  if (!isSuccess || isLoading || theme === FEELIX_THEMES.PARTNER || Boolean(activationCode) ||
    Boolean(addonIds?.length)) {
    return false;
  }
  const isPromoCodeBoxApplicable =
    (subscriptionType === SUBSCRIPTION_TYPE.SUBSCRIBE &&
      productData.items[0]?.deal?.isPromoCodeBoxApplicable) || false;

  return isSuccess && isPromoCodeBoxApplicable;
};
